
(function () {
  var rootClass = 'loncry-home-row-motion';
  var observer = null;
  var timer = null;

  function showRowsImmediately() {
    document.documentElement.classList.remove(rootClass);

    document
      .querySelectorAll(
        '.loncry-home-refresh .lh-products'
      )
      .forEach(function (row) {
        row.classList.add('is-visible');
      });
  }

  function prepareProductRowMotion() {
    var isMobile = window.matchMedia(
      '(max-width: 749px)'
    ).matches;

    var allowsMotion = window.matchMedia(
      '(prefers-reduced-motion: no-preference)'
    ).matches;

    if (!isMobile || !allowsMotion) {
      showRowsImmediately();
      return;
    }

    var rows = document.querySelectorAll(
      '.loncry-home-refresh .lh-products'
    );

    if (!rows.length) {
      return;
    }

    if (observer) {
      observer.disconnect();
    }

    document.documentElement.classList.remove(rootClass);

    rows.forEach(function (row) {
      row.classList.remove('is-visible');
    });

    /*
     * 强制浏览器清除上一次动画状态，
     * 确保刷新或返回首页时可以重新播放。
     */
    void document.documentElement.offsetWidth;

    document.documentElement.classList.add(rootClass);

    if (!('IntersectionObserver' in window)) {
      window.requestAnimationFrame(function () {
        rows.forEach(function (row) {
          row.classList.add('is-visible');
        });
      });

      return;
    }

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }

          window.requestAnimationFrame(function () {
            entry.target.classList.add('is-visible');
          });

          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -5% 0px'
      }
    );

    rows.forEach(function (row) {
      observer.observe(row);
    });
  }

  function scheduleProductRowMotion() {
    window.clearTimeout(timer);

    timer = window.setTimeout(function () {
      prepareProductRowMotion();
    }, 30);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      scheduleProductRowMotion,
      { once: true }
    );
  } else {
    scheduleProductRowMotion();
  }

  /*
   * 从商品页返回首页时重新播放。
   */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      scheduleProductRowMotion();
    }
  });

  /*
   * Shopify 编辑器重新加载板块时重新播放。
   */
  document.addEventListener(
    'shopify:section:load',
    scheduleProductRowMotion
  );
})();
